import React from "react";
const Expression = ({ expression = null, series }) => {
  if (!expression) {
    return "No condition configured";
  }
  switch (expression.expr) {
    case "number":
      return expression.value;
    case "number-ref":
      const selectedSeries = series.find((s) => s.id === expression.ref);
      return selectedSeries && selectedSeries.type ? /* @__PURE__ */ React.createElement("var", null, selectedSeries.type, "(", selectedSeries.strategy ? `${selectedSeries.strategy}, ` : null, selectedSeries.field, selectedSeries.percentile ? `, ${selectedSeries.percentile}` : null, ")") : /* @__PURE__ */ React.createElement("span", null, "No series selected");
    case "&&":
    case "||":
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Expression, { expression: expression.left, series }), " ", /* @__PURE__ */ React.createElement("strong", { className: "text-info" }, expression.expr === "&&" ? "AND" : "OR"), " ", /* @__PURE__ */ React.createElement(Expression, { expression: expression.right, series }));
    case "group":
      return /* @__PURE__ */ React.createElement("span", null, "[", /* @__PURE__ */ React.createElement(Expression, { expression: expression.child, series }), "]");
    case "<":
    case "<=":
    case ">":
    case ">=":
    case "==":
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Expression, { expression: expression.left, series }), " ", /* @__PURE__ */ React.createElement("strong", { className: "text-primary" }, expression.expr, " "), /* @__PURE__ */ React.createElement(Expression, { expression: expression.right, series }));
    default:
      return "No condition configured";
  }
};
const AggregationConditionSummary = ({ conditions, series }) => /* @__PURE__ */ React.createElement(Expression, { expression: conditions == null ? void 0 : conditions.expression, series });
export default AggregationConditionSummary;
